const lt_LT = {
  authors: 'autoriai',
  latest: 'naujausi',
  popular: 'populiariausi',
  search: 'paieska',
  author: 'autorius',
  issues: 'leidimai',
  issue: 'leidimas',
  issueLatest: 'leidimas/naujausias',
  category: 'kategorija',
  topics: 'temos',
  page: 'puslapis',
  article: 'straipsnis',
  comments: 'diskusija',
  bookmarks: 'pazymeti',
  forecast: 'prognoze',
};

export default lt_LT;
